
export class SearchAudanetTasksType {

     static ClaimNumber  = 1;
     static VIN  = 2;       
     static PlateNumber = 3; 
     
    }